var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.currentMedia != null)?_c('div',{class:_vm.containerClasses},[_c('SkinContainer'),_c('DFPContainer'),_c('PlayerManager'),_c('OnAirInfoBox'),_c('PlayerBar')],1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }